import { useCallback, useEffect } from "react";

import { usePagesStore, usePagesStoreActions } from "./pages_store";
import { selectPage } from "./pages_store_selectors";
import { PageStateKey } from "./pages_store_types";

export const usePage = <T extends Record<string, any>>(key: PageStateKey | string, initPage: T = {} as T) => {
  const page = (usePagesStore(selectPage(key)) ?? initPage) as T;
  const { createPage, updatePage, removePage } = usePagesStoreActions();

  useEffect(() => {
    createPage({ key, data: initPage });

    return () => removePage(key);
  }, [key]);

  const boundUpdatePage = useCallback((data: Partial<T>) => updatePage({ key, data }), [key, updatePage]);

  return { page, updatePage: boundUpdatePage };
};
